import React from 'react';
import images from 'assets/img';
import BranchHeader from './BranchHeader';
import { withTranslation } from 'react-i18next';

export default withTranslation()(function EmptyBranch({t}) {

  return (
    <div className="w-full bg-white py-8 px-12 rounded-xl mb-5 shadow-sm">
      <BranchHeader />

      <div className="w-full h-80 flex flex-col items-center justify-center">
        <div className="w-24 h-24 flex justify-center mb-7 items-center rounded-full bg-border-lines">
          <img src={images.Store} alt="" className="w-16 h-16" />
        </div>
        
        <p className="text-placeholder w-3/5 mx-auto text-center">{ t('settings.branch.empty') }</p>
      </div>
    </div>
  )
})
